export default "__VITE_ASSET__B2$JG8Re__"